import Unauthenticated from './Unauthenticated'
import Authenticated from './Authenticated'

export const AuthGuard = {
  Unauthenticated,
  Authenticated,
}
